import { createContext } from 'react'
import type { UseModalContextType } from '../types'

export const ModalContext = createContext({} as UseModalContextType)
